/* Brixmor integrated client header — megamenu + footer sync */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        initMegamenus();
        initFooterSync();
        initKlaroFooterLink();
        initStickyHeaderHeight();
    });

    function syncStickyHeaderHeight() {
        var header = document.querySelector('.integrated-site-header-desktop');
        if (!header || window.getComputedStyle(header).display === 'none') {
            return;
        }

        document.documentElement.style.setProperty(
            '--client-header-height',
            header.offsetHeight + 'px'
        );
    }

    function initStickyHeaderHeight() {
        syncStickyHeaderHeight();
        window.addEventListener('resize', syncStickyHeaderHeight);

        var header = document.querySelector('.integrated-site-header-desktop');
        if (header && typeof ResizeObserver === 'function') {
            var observer = new ResizeObserver(syncStickyHeaderHeight);
            observer.observe(header);
        }
    }

    function isMegamenuFocusableVisible(el) {
        if (!el || el.disabled) return false;
        var node = el;
        while (node) {
            if (node.classList) {
                if (node.classList.contains('client-megamenu-is-hidden')) return false;
                if (node.classList.contains('client-megamenu-suppressed')) return false;
            }
            if (node.hidden) return false;
            node = node.parentElement;
        }
        var panel = el.closest('.client-megamenu-panel');
        if (panel && panel.hidden) return false;
        return el.getClientRects().length > 0;
    }

    function getPanelFocusables(panel) {
        if (!panel || panel.hidden) return [];
        return Array.from(panel.querySelectorAll('a[href], button:not([disabled])')).filter(isMegamenuFocusableVisible);
    }

    function getMainNavFocusables(header) {
        var nav = header.querySelector('nav[aria-label="Main"]');
        if (!nav) return [];
        return Array.from(nav.querySelectorAll('a[href], button:not([disabled])'));
    }

    function syncPanelTabIndex(panel) {
        if (!panel) return;
        panel.querySelectorAll('a[href], button:not([disabled])').forEach(function (el) {
            if (isMegamenuFocusableVisible(el)) {
                el.removeAttribute('tabindex');
            } else {
                el.setAttribute('tabindex', '-1');
            }
        });
    }

    function focusFirstPanelItem(panel) {
        syncPanelTabIndex(panel);
        var focusables = getPanelFocusables(panel);
        if (focusables.length) {
            focusables[0].focus();
        }
    }

    function initMegamenus() {
        var header = document.getElementById('client-header');
        if (!header) return;

        var triggers = header.querySelectorAll('[data-client-megamenu-trigger]');
        var panels = header.querySelectorAll('.client-megamenu-panel');
        if (!triggers.length) return;

        var openPanel = null;
        var openTrigger = null;
        var closeTimer = null;

        panels.forEach(function (panel) {
            initPanelInteractions(panel, function () {
                syncPanelTabIndex(panel);
            });
            bindPanelKeyboard(panel, header, function () {
                return { openPanel: openPanel, openTrigger: openTrigger };
            }, closeAllAndFocusTrigger, closeAllAndFocusNextMain);
        });

        function closeAll() {
            panels.forEach(function (panel) {
                panel.hidden = true;
                panel.classList.remove('is-open');
            });
            triggers.forEach(function (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
                trigger.classList.remove('client-megamenu-trigger--open');
                trigger.removeAttribute('aria-controls');
            });
            openPanel = null;
            openTrigger = null;
        }

        function closeAllAndFocusTrigger(trigger) {
            closeAll();
            if (trigger) trigger.focus();
        }

        function closeAllAndFocusNextMain(trigger) {
            var mainNav = getMainNavFocusables(header);
            var index = mainNav.indexOf(trigger);
            closeAll();
            if (index >= 0 && mainNav[index + 1]) {
                mainNav[index + 1].focus();
            }
        }

        function openMenu(trigger, panelId, moveFocusIntoPanel) {
            if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
            }
            var panel = document.getElementById(panelId);
            if (!panel) return;

            panels.forEach(function (p) {
                if (p !== panel) {
                    p.hidden = true;
                    p.classList.remove('is-open');
                }
            });
            triggers.forEach(function (t) {
                if (t !== trigger) {
                    t.setAttribute('aria-expanded', 'false');
                    t.classList.remove('client-megamenu-trigger--open');
                    t.removeAttribute('aria-controls');
                }
            });

            panel.hidden = false;
            panel.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            trigger.setAttribute('aria-controls', panelId);
            trigger.classList.add('client-megamenu-trigger--open');
            openPanel = panel;
            openTrigger = trigger;
            resetPanelState(panel);
            syncPanelTabIndex(panel);

            if (moveFocusIntoPanel) {
                focusFirstPanelItem(panel);
            }
        }

        function shouldKeepOpen() {
            if (openPanel && openPanel.contains(document.activeElement)) return true;
            if (openTrigger && document.activeElement === openTrigger) return true;
            return false;
        }

        function scheduleClose() {
            if (shouldKeepOpen()) return;
            if (closeTimer) clearTimeout(closeTimer);
            closeTimer = setTimeout(closeAll, 150);
        }

        triggers.forEach(function (trigger) {
            var key = trigger.getAttribute('data-client-megamenu-trigger');
            var panelId = 'megamenu-panel-' + key;
            var li = trigger.closest('li');

            trigger.addEventListener('mouseenter', function () {
                openMenu(trigger, panelId, false);
            });
            trigger.addEventListener('focus', function () {
                openMenu(trigger, panelId, false);
            });

            if (li) {
                li.addEventListener('mouseleave', scheduleClose);
            }

            var panel = document.getElementById(panelId);
            if (panel) {
                panel.addEventListener('mouseenter', function () {
                    if (closeTimer) {
                        clearTimeout(closeTimer);
                        closeTimer = null;
                    }
                });
                panel.addEventListener('mouseleave', scheduleClose);
            }

            trigger.addEventListener('keydown', function (e) {
                if (e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    openMenu(trigger, panelId, true);
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    closeAllAndFocusTrigger(trigger);
                }
            });
        });

        var mainNav = header.querySelector('nav[aria-label="Main"]');
        if (mainNav) {
            mainNav.addEventListener('focusin', function (e) {
                if (!openPanel && !openTrigger) return;
                var target = e.target;
                if (openPanel && openPanel.contains(target)) return;
                if (openTrigger && openTrigger === target) return;
                closeAll();
            });
        }

        header.addEventListener('focusin', function (e) {
            if (!openPanel && !openTrigger) return;
            if (mainNav && mainNav.contains(e.target)) return;
            var target = e.target;
            if (openPanel && openPanel.contains(target)) return;
            if (openTrigger && openTrigger === target) return;
            closeAll();
        });

        header.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && openTrigger) {
                e.preventDefault();
                closeAllAndFocusTrigger(openTrigger);
            }
        });

        document.addEventListener('mousedown', function (e) {
            if (!header.contains(e.target)) {
                closeAll();
            }
        });

        function bindPanelKeyboard(panel, headerEl, getState, closeToTrigger, closeToNextMain) {
            panel.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    e.preventDefault();
                    var state = getState();
                    closeToTrigger(state.openTrigger);
                    return;
                }

                if (e.key !== 'Tab') return;

                var state = getState();
                if (!state.openPanel || state.openPanel !== panel || !state.openTrigger) return;

                syncPanelTabIndex(panel);
                var focusables = getPanelFocusables(panel);
                if (!focusables.length) return;

                var first = focusables[0];
                var last = focusables[focusables.length - 1];

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    closeToTrigger(state.openTrigger);
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    closeToNextMain(state.openTrigger);
                }
            });
        }
    }

    function initPanelInteractions(panel, onStateChange) {
        var leftItems = panel.querySelectorAll('.client-megamenu-left-item');
        if (!leftItems.length) return;

        leftItems.forEach(function (leftItem) {
            var leftIndex = leftItem.getAttribute('data-left-index');
            var trigger = leftItem.querySelector('.client-megamenu-left-trigger');

            function activateLeft() {
                setActiveLeft(panel, leftIndex);
                if (onStateChange) onStateChange();
            }

            leftItem.addEventListener('mouseenter', activateLeft);
            if (trigger) {
                trigger.addEventListener('focus', activateLeft);
            }
        });

        panel.querySelectorAll('.client-megamenu-middle-item').forEach(function (middleItem) {
            var middleIndex = middleItem.getAttribute('data-middle-index');
            var parentGroup = middleItem.closest('.client-megamenu-middle-group');
            var leftIndex = parentGroup ? parentGroup.getAttribute('data-middle-for') : null;

            function activateMiddle() {
                if (leftIndex !== null) {
                    setActiveLeft(panel, leftIndex);
                }
                setActiveMiddle(panel, leftIndex, middleIndex);
                if (onStateChange) onStateChange();
            }

            middleItem.addEventListener('mouseenter', activateMiddle);
            var focusable = middleItem.querySelector('a, button');
            if (focusable) {
                focusable.addEventListener('focus', activateMiddle);
            }
        });

    }

    function resetPanelState(panel) {
        var firstLeft = panel.querySelector('.client-megamenu-left-item');
        if (!firstLeft) return;
        setActiveLeft(panel, firstLeft.getAttribute('data-left-index'));
    }

    function setActiveLeft(panel, leftIndex) {
        panel.querySelectorAll('.client-megamenu-left-item').forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('data-left-index') === String(leftIndex));
        });

        var middleCol = panel.querySelector('div[data-megamenu-col="middle"]');
        var divider = panel.querySelector('.client-megamenu-divider:not(.client-megamenu-divider-right)');
        var middleGroup = panel.querySelector('.client-megamenu-middle-group[data-middle-for="' + leftIndex + '"]');
        var detail = panel.querySelector('.client-megamenu-detail[data-detail-for="' + leftIndex + '"]');
        var hasMiddle = !!(middleGroup || detail);

        if (middleCol) {
            middleCol.classList.toggle('client-megamenu-is-hidden', !hasMiddle);
        }
        if (divider) {
            divider.classList.toggle('client-megamenu-is-hidden', !hasMiddle);
        }

        panel.querySelectorAll('.client-megamenu-middle-group').forEach(function (group) {
            group.classList.toggle('client-megamenu-is-hidden', group.getAttribute('data-middle-for') !== String(leftIndex));
        });

        panel.querySelectorAll('.client-megamenu-detail').forEach(function (detailEl) {
            detailEl.classList.toggle('client-megamenu-is-hidden', detailEl.getAttribute('data-detail-for') !== String(leftIndex));
        });

        panel.querySelectorAll('.client-megamenu-right-photo, .client-megamenu-image').forEach(function (image) {
            var show = image.getAttribute('data-image-for') === String(leftIndex);
            image.classList.toggle('client-megamenu-is-hidden', !show);
        });

        var rightImageCol = panel.querySelector('[data-megamenu-col="right-image"]');
        var hasImage = panel.querySelector('.client-megamenu-right-photo[data-image-for="' + leftIndex + '"], .client-megamenu-image[data-image-for="' + leftIndex + '"]');
        if (rightImageCol) {
            rightImageCol.classList.toggle('client-megamenu-suppressed', !hasImage);
            var photoDivider = panel.querySelector('.client-megamenu-divider-right');
            if (photoDivider) {
                photoDivider.classList.toggle('client-megamenu-suppressed', !hasImage);
            }
        }

        if (middleCol) {
            var showingList = middleGroup && !middleGroup.classList.contains('client-megamenu-is-hidden');
            middleCol.classList.toggle('min-w-[300px]', !showingList);
        }

        if (middleGroup) {
            var firstMiddle = middleGroup.querySelector('.client-megamenu-middle-item');
            if (firstMiddle) {
                setActiveMiddle(panel, leftIndex, firstMiddle.getAttribute('data-middle-index'));
            } else {
                updatePropertiesRightColumn(panel, leftIndex, null);
            }
        } else {
            hidePropertiesRightColumn(panel);
        }

        syncPanelTabIndex(panel);
    }

    function setActiveMiddle(panel, leftIndex, middleIndex) {
        var middleGroup = panel.querySelector('.client-megamenu-middle-group[data-middle-for="' + leftIndex + '"]');
        if (!middleGroup) return;

        middleGroup.querySelectorAll('.client-megamenu-middle-item').forEach(function (item) {
            item.classList.toggle('is-active', item.getAttribute('data-middle-index') === String(middleIndex));
        });

        updatePropertiesRightColumn(panel, leftIndex, middleIndex);
        syncPanelTabIndex(panel);
    }

    function updatePropertiesRightColumn(panel, leftIndex, middleIndex) {
        var key = leftIndex + '-' + middleIndex;
        var showRight = false;

        panel.querySelectorAll('.client-megamenu-right-group').forEach(function (group) {
            var show = group.getAttribute('data-right-for') === key;
            group.classList.toggle('client-megamenu-is-hidden', !show);
            if (show) showRight = true;
        });

        var dividerRight = panel.querySelector('#megamenu-panel-properties .client-megamenu-divider-right');
        if (dividerRight) {
            dividerRight.classList.toggle('client-megamenu-is-hidden', !showRight);
        }
    }

    function hidePropertiesRightColumn(panel) {
        panel.querySelectorAll('.client-megamenu-right-group').forEach(function (el) {
            el.classList.add('client-megamenu-is-hidden');
        });
        var dividerRight = panel.querySelector('#megamenu-panel-properties .client-megamenu-divider-right');
        if (dividerRight) {
            dividerRight.classList.add('client-megamenu-is-hidden');
        }
    }

    function initFooterSync() {
        var brand = document.getElementById('client-footer-brand');
        var footerMain = document.querySelector('[data-footer-main]');
        if (!brand || !footerMain) return;

        function sync() {
            var rect = brand.getBoundingClientRect();
            var parentRect = footerMain.getBoundingClientRect();
            var left = rect.left - parentRect.left + rect.width / 2;
            footerMain.style.setProperty('--footer-x-left', left + 'px');
        }

        sync();
        window.addEventListener('resize', sync);
    }

    function initKlaroFooterLink() {
        var footerBtn = document.getElementById('klaroPrefsFooter');
        var klaroBtn = document.getElementById('klaroPrefs');
        if (!footerBtn || !klaroBtn) return;

        footerBtn.addEventListener('click', function (e) {
            e.preventDefault();
            klaroBtn.click();
        });
    }
})();
